/*
  VERSA v35 integrated scripts
  - Initialises per container so it re-runs when the Shopify Theme Editor
    re-renders a section (shopify:section:load). Previously everything only ran
    on DOMContentLoaded, so carousels/swatches/sliders stopped working in the
    editor after any setting change until the preview was refreshed.
  - Adds touch swipe to carousels + review sliders, keyboard/backdrop closing
    for the video modal, sold-out state for swatch variants, and click/tap
    support for desktop dropdowns (tablets have no hover).
*/
(function () {
  'use strict';

  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var $ = function (s, c) { return (c || document).querySelector(s); };

  // Run fn once per element (prevents double-binding when the editor reloads a section)
  function once(el, key, fn) {
    var flag = 'v35' + key;
    if (el.dataset[flag]) return;
    el.dataset[flag] = '1';
    fn(el);
  }

  // Horizontal swipe helper (vertical scrolling is left untouched)
  function onSwipe(el, onNext, onPrev) {
    var x0 = null, y0 = null;
    el.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 1) return;
      x0 = e.touches[0].clientX; y0 = e.touches[0].clientY;
    }, { passive: true });
    el.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var t = e.changedTouches[0], dx = t.clientX - x0, dy = t.clientY - y0;
      x0 = y0 = null;
      if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy) * 1.2) return;
      if (dx < 0) onNext(); else onPrev();
    }, { passive: true });
  }

  function setImage(img, src, srcset) {
    if (!img || !src) return;
    if (srcset) { img.setAttribute('srcset', srcset); } else { img.removeAttribute('srcset'); }
    img.src = src;
  }

  /* ---------- Announcement bar ---------- */
  function initAnnouncement(root) {
    $$('.v35-announcement', root).forEach(function (bar) {
      once(bar, 'Ann', function () {
        var items = $$('.v35-announcement__item', bar);
        if (!items.length) return;
        var i = 0;
        items.forEach(function (x, n) { x.classList.toggle('is-active', n === 0); });
        var speed = parseInt(bar.dataset.speed || '3600', 10);
        if (items.length > 1) {
          bar._v35timer = setInterval(function () {
            items[i].classList.remove('is-active');
            i = (i + 1) % items.length;
            items[i].classList.add('is-active');
          }, speed);
        }
      });
    });
  }

  /* ---------- Header: mobile nav, mega menu, dropdowns ---------- */
  function initHeader(root) {
    $$('[data-v35-mobile-toggle]', root).forEach(function (btn) {
      once(btn, 'Toggle', function () {
        btn.addEventListener('click', function () {
          var nav = document.getElementById(btn.getAttribute('aria-controls'));
          if (!nav) return;
          var open = nav.classList.toggle('is-open');
          btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        });
      });
    });

    $$('[data-v35-mega], [data-v35-drop]', root).forEach(function (menu) {
      once(menu, 'Menu', function () {
        var trig = $('[data-v35-mega-trigger], [data-v35-drop-trigger]', menu);
        if (!trig) return;
        trig.addEventListener('click', function (e) {
          e.preventDefault();
          var open = !menu.classList.contains('is-open');
          closeMenus(menu);
          menu.classList.toggle('is-open', open);
          trig.setAttribute('aria-expanded', open ? 'true' : 'false');
        });
      });
    });
  }

  function closeMenus(except) {
    $$('[data-v35-mega].is-open, [data-v35-drop].is-open').forEach(function (m) {
      if (m === except) return;
      m.classList.remove('is-open');
      var t = $('[data-v35-mega-trigger], [data-v35-drop-trigger]', m);
      if (t) t.setAttribute('aria-expanded', 'false');
    });
  }

  /* ---------- Media carousels ---------- */
  function initCarousels(root) {
    $$('[data-v35-carousel]', root).forEach(function (car) {
      once(car, 'Car', function () {
        var track = $('[data-v35-track]', car), slides = $$('[data-v35-slide]', car), thumbs = $$('[data-v35-thumb]', car);
        if (!track || !slides.length) return;
        var idx = 0;
        var go = function (n) {
          idx = (n + slides.length) % slides.length;
          track.style.transform = 'translateX(-' + (idx * 100) + '%)';
          thumbs.forEach(function (t, i) {
            t.classList.toggle('is-active', i === idx);
            t.setAttribute('aria-current', i === idx ? 'true' : 'false');
          });
          /* keep the active thumbnail visible in the one-line strip */
          var at = thumbs[idx], strip = at && at.parentElement;
          if (strip && strip.scrollWidth > strip.clientWidth) {
            var l = at.offsetLeft, r = l + at.offsetWidth;
            if (l < strip.scrollLeft || r > strip.scrollLeft + strip.clientWidth) {
              strip.scrollTo({ left: Math.max(0, l - (strip.clientWidth - at.offsetWidth) / 2), behavior: 'smooth' });
            }
          }
          slides.forEach(function (s, i) {
            s.setAttribute('aria-hidden', i === idx ? 'false' : 'true');
            $$('video', s).forEach(function (v) {
              if (i !== idx) { v.pause(); }
              else if (v.hasAttribute('autoplay')) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
            });
          });
        };
        $$('[data-v35-prev]', car).forEach(function (b) { b.addEventListener('click', function () { go(idx - 1); }); });
        $$('[data-v35-next]', car).forEach(function (b) { b.addEventListener('click', function () { go(idx + 1); }); });
        thumbs.forEach(function (t, i) { t.addEventListener('click', function () { go(i); }); });
        var stage = $('.v35-carousel__stage', car) || car;
        onSwipe(stage, function () { go(idx + 1); }, function () { go(idx - 1); });
        $$('[data-v35-goto-last]', car).forEach(function (b) {
          b.addEventListener('click', function () {
            go(slides.length - 1);
            var v = $('video', slides[slides.length - 1]);
            if (v) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
          });
        });
        car._v35go = go;
        go(0);
      });
    });
  }

  /* ---------- Review sliders (several cards per view on desktop, dots, swipe) ---------- */
  function initReviews(root) {
    $$('[data-v35-reviews]', root).forEach(function (rv) {
      once(rv, 'Rev', function () {
        var track = $('[data-v35-review-track]', rv), cards = $$('[data-v35-review]', rv);
        var controls = $('.v35-review-controls', rv), dotsWrap = $('[data-v35-review-dots]', rv);
        if (!track || !cards.length) return;
        var idx = 0, pages = 1;
        var perView = function () {
          var cw = cards[0].getBoundingClientRect().width || 1;
          var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
          return Math.max(1, Math.round((rv.clientWidth + gap) / (cw + gap)));
        };
        var buildDots = function () {
          pages = Math.max(1, cards.length - perView() + 1);
          if (controls) controls.style.display = pages < 2 ? 'none' : '';
          if (!dotsWrap) return;
          dotsWrap.innerHTML = '';
          for (var i = 0; i < pages; i++) {
            var d = document.createElement('button');
            d.type = 'button';
            d.setAttribute('aria-label', 'Show review ' + (i + 1));
            (function (n) { d.addEventListener('click', function () { go(n); }); })(i);
            dotsWrap.appendChild(d);
          }
        };
        var go = function (n) {
          idx = (n + pages) % pages;
          // never slide past the last full view (desktop shows several cards at once)
          var maxOffset = Math.max(0, track.scrollWidth - rv.clientWidth);
          var offset = Math.min(cards[idx].offsetLeft - cards[0].offsetLeft, maxOffset);
          track.style.transform = 'translateX(-' + offset + 'px)';
          var pv = perView();
          var first = Math.min(idx, cards.length - pv);
          cards.forEach(function (c, i) { c.setAttribute('aria-hidden', (i >= first && i < first + pv) ? 'false' : 'true'); c.classList.toggle('is-current', i === idx); });
          if (dotsWrap) $$('button', dotsWrap).forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
        };
        var prev = $('[data-v35-review-prev]', rv), next = $('[data-v35-review-next]', rv);
        if (prev) prev.addEventListener('click', function () { go(idx - 1); });
        if (next) next.addEventListener('click', function () { go(idx + 1); });
        onSwipe(rv, function () { go(idx + 1); }, function () { go(idx - 1); });
        var t;
        window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(function () { buildDots(); go(Math.min(idx, pages - 1)); }, 150); });
        rv._v35go = function (n) { go(Math.min(n, pages - 1)); };
        rv._v35cards = cards;
        buildDots();
        go(0);
      });
    });
  }



  /* ---------- Award sliders (fixed cards; arrows only when overflow exists) ---------- */
  function initAwards(root) {
    $$('[data-v35-awards]', root).forEach(function (slider) {
      once(slider, 'Aw', function () {
        var track = $('[data-v35-award-track]', slider);
        if (!track) return;
        var prev = $('[data-v35-award-prev]', slider), next = $('[data-v35-award-next]', slider);
        var amount = function () {
          var card = track.querySelector('.v35-proof-tile');
          if (!card) return Math.max(280, Math.round(track.clientWidth * .82));
          var gap = parseFloat(window.getComputedStyle(track).gap || 14);
          return Math.round(card.getBoundingClientRect().width + gap);
        };
        var move = function (dir) { track.scrollBy({ left: dir * amount(), behavior: 'smooth' }); };
        var updateControls = function () {
          var overflow = track.scrollWidth > track.clientWidth + 2;
          slider.classList.toggle('has-overflow', overflow);
          if (!overflow) {
            if (prev) prev.classList.add('is-disabled');
            if (next) next.classList.add('is-disabled');
            return;
          }
          var max = Math.max(0, track.scrollWidth - track.clientWidth - 2);
          if (prev) prev.classList.toggle('is-disabled', track.scrollLeft <= 2);
          if (next) next.classList.toggle('is-disabled', track.scrollLeft >= max);
        };
        if (prev) prev.addEventListener('click', function () { move(-1); });
        if (next) next.addEventListener('click', function () { move(1); });
        onSwipe(track, function () { move(1); }, function () { move(-1); });
        track.addEventListener('scroll', function () { window.requestAnimationFrame(updateControls); }, { passive: true });
        var resizeTimer;
        window.addEventListener('resize', function () { clearTimeout(resizeTimer); resizeTimer = setTimeout(updateControls, 120); });
        updateControls(); setTimeout(updateControls, 80);
      });
    });
  }

  /* ---------- Full-width colour selector ---------- */
  function initColorHeroes(root) {
    $$('[data-v35-color-hero]', root).forEach(function (scope) {
      once(scope, 'Hero', function () {
        var bg = $('[data-v35-color-image]', scope), label = $('[data-v35-color-name]', scope), buttons = $$('[data-v35-color-button]', scope);
        buttons.forEach(function (btn) {
          btn.addEventListener('click', function () {
            buttons.forEach(function (b) { b.classList.remove('is-active'); b.setAttribute('aria-pressed', 'false'); });
            btn.classList.add('is-active'); btn.setAttribute('aria-pressed', 'true');
            setImage(bg, btn.dataset.image, btn.dataset.srcset);
            if (label) label.textContent = btn.dataset.name || '';
          });
        });
      });
    });
  }

  /* ---------- Add-to-cart state helpers ---------- */
  function setBuyState(root, available, price) {
    $$('[data-v35-add]', root).forEach(function (b) {
      var ok = available !== 'false';
      b.disabled = !ok;
      var txt = ok ? b.dataset.labelAdd : b.dataset.labelSold;
      if (ok && txt && price && b.dataset.labelPrice === 'true') txt += ' \u2014 ' + price;
      if (txt) b.textContent = txt;
    });
  }

  function setPrice(root, price, compare) {
    var now = $('[data-v35-price-now]', root), cmp = $('[data-v35-price-compare]', root), save = $('[data-v35-price-save]', root);
    if (now && price) now.textContent = price;
    if (cmp) { cmp.textContent = compare || ''; cmp.style.display = compare ? '' : 'none'; }
    if (save) save.style.display = compare ? '' : 'none';
  }

  /* ---------- Commerce colour swatches (product + DRTV) ---------- */
  function initCommerceColors(root) {
    $$('[data-v35-commerce-colors]', root).forEach(function (scope) {
      once(scope, 'Cc', function () {
        var buttons = $$('[data-v35-commerce-color]', scope),
          sec = scope.closest('.v35-commerce') || document,
          hero = $('[data-v35-featured-color-image]', sec),
          thumb = $('[data-v35-product-thumb] img', sec),
          label = $('[data-v35-color-name]', scope),
          form = scope.closest('form') || $('form', sec),
          variantSelect = form ? form.querySelector('[name="id"]') : null,
          offer = scope.closest('.v35-offer') || sec,
          carousel = $('[data-v35-carousel]', sec);
        buttons.forEach(function (btn) {
          btn.addEventListener('click', function () {
            buttons.forEach(function (b) { b.classList.remove('is-active'); b.setAttribute('aria-pressed', 'false'); });
            btn.classList.add('is-active'); btn.setAttribute('aria-pressed', 'true');
            if (label) label.textContent = btn.dataset.name || '';
            if (hero && btn.dataset.image) { setImage(hero, btn.dataset.image, btn.dataset.srcset); hero.alt = btn.dataset.alt || hero.alt; }
            if (thumb && btn.dataset.image) setImage(thumb, btn.dataset.image, '');
            if (btn.dataset.variantId && variantSelect) {
              variantSelect.value = btn.dataset.variantId;
              variantSelect.dispatchEvent(new Event('change', { bubbles: true }));
              setPrice(offer, btn.dataset.price, btn.dataset.compare);
              setBuyState(offer, btn.dataset.available, btn.dataset.price);
              var sp = $('[data-v35-sticky-price]', sec); if (sp && btn.dataset.price) sp.textContent = btn.dataset.price; var svi=$('[data-v35-sticky-variant]',sec); if(svi && btn.dataset.variantId && svi.dataset.v35FixedSku !== 'true') svi.value=btn.dataset.variantId;
              $$('[data-v35-quick-variant]', sec).forEach(function(inp){ if(btn.dataset.variantId && inp.dataset.v35FixedSku !== 'true') inp.value=btn.dataset.variantId; });
              $$('[data-v35-quick-price]', sec).forEach(function(el){ if(btn.dataset.price) el.textContent=btn.dataset.price; });
              $$('[data-v35-quick-compare]', sec).forEach(function(el){ el.textContent=btn.dataset.compare||''; el.style.display=btn.dataset.compare?'':'none'; });
              setBuyState(sec, btn.dataset.available, btn.dataset.price);
            }
            if (carousel && carousel._v35go) carousel._v35go(1);
          });
        });
      });
    });
  }

  /* ---------- Final offer swatches (DRTV) ---------- */
  function initFinalColors(root) {
    $$('[data-v35-final-colors]', root).forEach(function (scope) {
      once(scope, 'Fc', function () {
        var sec = scope.closest('.v35-final-offer'), img = sec ? $('[data-v35-final-image]', sec) : null,
          label = $('[data-v35-color-name]', scope), buttons = $$('[data-v35-final-color]', scope);
        buttons.forEach(function (btn) {
          btn.addEventListener('click', function () {
            buttons.forEach(function (b) { b.classList.remove('is-active'); b.setAttribute('aria-pressed', 'false'); });
            btn.classList.add('is-active'); btn.setAttribute('aria-pressed', 'true');
            setImage(img, btn.dataset.image, btn.dataset.srcset);
            if (label) label.textContent = btn.dataset.name || '';
            var input = sec ? $('[data-v35-final-variant]', sec) : null;
            if (input && btn.dataset.variantId && input.dataset.v35FixedSku !== 'true') {
              input.value = btn.dataset.variantId;
              setBuyState(input.closest('form'), btn.dataset.available, btn.dataset.price);
            }
          });
        });
      });
    });
  }

  /* ---------- Visible variant <select> (bags) ---------- */
  function initVariantSelects(root) {
    $$('[data-v35-variant-select]', root).forEach(function (sel) {
      once(sel, 'Vs', function () {
        var offer = sel.closest('.v35-offer') || document;
        sel.addEventListener('change', function () {
          var o = sel.options[sel.selectedIndex];
          if (!o) return;
          setPrice(offer, o.dataset.price, o.dataset.compare);
          setBuyState(offer, o.dataset.available, o.dataset.price);
        });
      });
    });
  }

  /* ---------- Video modal ---------- */
  function openModal(m) {
    m.style.display = 'grid';
    m.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    var v = $('video', m);
    if (v) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
    var c = $('[data-v35-modal-close]', m); if (c) c.focus();
  }
  function closeModal(m) {
    if (!m || m.style.display === 'none') return;
    m.style.display = 'none';
    m.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    var v = $('video', m); if (v) v.pause();
    if (m._v35opener) m._v35opener.focus();
  }
  function initModals(root) {
    $$('[data-v35-modal-open]', root).forEach(function (btn) {
      once(btn, 'Mo', function () {
        btn.addEventListener('click', function () {
          var m = document.getElementById(btn.dataset.v35ModalOpen);
          if (!m) return;
          m._v35opener = btn;
          openModal(m);
        });
      });
    });
    $$('[data-v35-modal]', root).forEach(function (m) {
      once(m, 'Md', function () {
        m.addEventListener('click', function (e) { if (e.target === m) closeModal(m); });
        $$('[data-v35-modal-close]', m).forEach(function (b) { b.addEventListener('click', function () { closeModal(m); }); });
      });
    });
  }


  /* ---------- DRTV mobile sticky buy visibility ---------- */
  function initStickyBuy(root) {
    $$('[data-v35-sticky]', root).forEach(function (sticky) {
      once(sticky, 'St', function () {
        var host = sticky.closest('.shopify-section') || document;
        var boxes = $$('[data-v35-buy-box]', host);
        var visible = new Set();
        var dropdownOpen = function () {
          if ($$('details[open]:not(.v35-accordion__item)', host).length) return true; /* product accordions shouldn't hide the buy bar */
          if (document.querySelector('.v35-header [aria-expanded="true"]')) return true;
          if (document.querySelector('.v35-header details[open]')) return true;
          return false;
        };
        var update = function () {
          var hide = visible.size > 0 || dropdownOpen();
          sticky.classList.toggle('is-hidden', hide);
          sticky.setAttribute('aria-hidden', hide ? 'true' : 'false');
        };
        if ('IntersectionObserver' in window) {
          var obs = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting && entry.intersectionRatio > 0.08) visible.add(entry.target);
              else visible.delete(entry.target);
            });
            update();
          }, { threshold: [0, .08, .2, .5] });
          boxes.forEach(function (box) { obs.observe(box); });
          sticky._v35observer = obs;
        }
        $$('details', host).forEach(function (d) { d.addEventListener('toggle', update); });
        document.addEventListener('click', function () { setTimeout(update, 20); });
        document.addEventListener('keyup', function () { setTimeout(update, 20); });
        window.addEventListener('resize', update);
        update();
      });
    });
  }

  function init(root) {
    root = root || document;
    initAnnouncement(root);
    initHeader(root);
    initCarousels(root);
    initReviews(root);
    initAwards(root);
    initColorHeroes(root);
    initCommerceColors(root);
    initFinalColors(root);
    initVariantSelects(root);
    initModals(root);
    initStickyBuy(root);
  }

  /* ---------- Global listeners (bound once) ---------- */
  document.addEventListener('click', function (e) {
    if (!e.target.closest || !e.target.closest('[data-v35-mega], [data-v35-drop]')) closeMenus(null);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    closeMenus(null);
    $$('[data-v35-modal]').forEach(closeModal);
  });

  /* ---------- Shopify Theme Editor support ---------- */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    $$('.v35-announcement', e.target).forEach(function (bar) { if (bar._v35timer) clearInterval(bar._v35timer); });
    document.body.style.overflow = '';
  });
  document.addEventListener('shopify:block:select', function (e) {
    var block = e.target;
    if (!block || !block.matches) return;
    // Reviews: slide to the selected review
    if (block.hasAttribute('data-v35-review')) {
      var rv = block.closest('[data-v35-reviews]');
      if (rv && rv._v35go) rv._v35go(rv._v35cards.indexOf(block));
    }
    // Colour swatches: preview the selected colour
    if (block.matches('[data-v35-color-button], [data-v35-commerce-color], [data-v35-final-color]')) block.click();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
})();


/* ---------- v44 modern cart contact/address capture ---------- */
document.addEventListener('DOMContentLoaded', function(){
  var cart = document.querySelector('[data-v44-cart]');
  if(!cart) return;
  var fields = Array.prototype.slice.call(cart.querySelectorAll('[data-v44-checkout-field]'));
  var timer;
  function attributes(){
    var a={};
    fields.forEach(function(f){ a[f.getAttribute('data-v44-attribute')] = f.value || ''; });
    return a;
  }
  function persist(){
    if(!fields.length) return Promise.resolve();
    return fetch('/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({attributes:attributes()})}).catch(function(){});
  }
  fields.forEach(function(f){
    f.addEventListener('change',persist);
    f.addEventListener('input',function(){clearTimeout(timer);timer=setTimeout(persist,450);});
  });
  var checkout=cart.querySelector('[data-v44-checkout]');
  if(checkout){
    checkout.addEventListener('click',function(){
      var required=fields.filter(function(f){return f.required && !f.value.trim();});
      if(required.length){ required[0].focus(); cart.classList.add('v44-cart--needs-fields'); return; }
      checkout.disabled=true; checkout.classList.add('is-loading');
      persist().finally(function(){
        var q=new URLSearchParams();
        fields.forEach(function(f){
          var key=f.getAttribute('data-v44-checkout-param');
          if(key && f.value.trim()) q.append(key,f.value.trim());
        });
        window.location.href='/checkout'+(q.toString()?'?'+q.toString():'');
      });
    });
  }
});
